// extracted by mini-css-extract-plugin
export default {"MonthsNavigation":"XPxJH","activeMonthBox":"esc3w","wrap":"j7d9t","months":"_5jdQz","month":"QbR6y","year":"_4--VV","skeleton-progress":"w5uEK"};